import {useEventContext} from "../../contexts/EventContext";
import AttendeeForm from "./AttendeeForm";

export default function AttendeesForm() {
    const { attendeeQty } = useEventContext();
    let attendees = [];

    for (let i = 0; i < attendeeQty; i++) {
        attendees.push(<AttendeeForm index={i} />)
    }

    return <>{attendees.map(attendee => attendee)}</>;
}
